import React, { useEffect, useState } from "react";
import { Table } from "antd";

const EMPTY_TOTAL = {
  count: 1,
  gameRank: 0,
  totalTime: 0,
  meteor: 0,
  treeOfLife: 0,
  alpha: 0,
  omega: 0,
  wickline: 0,
  purpleBox: 0,
  redBox: 0,
  total: 0
};
const TOTAL_SUPPLY = 22;

export default function AvgStatByGame({ data, loading }) {
  const [total, setTotal] = useState([EMPTY_TOTAL]);

  useEffect(() => {
    if (data && data.length !== 0) {
      const totals = { ...EMPTY_TOTAL };

      data.forEach(game => {
        totals.gameRank += game.gameRank;
        totals.totalTime += game.totalTime;
        totals.meteor += game.earnedItem.meteor;
        totals.treeOfLife += game.earnedItem.treeOfLife;
        totals.alpha += game.earnedItem.alpha;
        totals.omega += game.earnedItem.omega;
        totals.wickline += game.earnedItem.wickline;
        totals.purpleBox += game.earnedItem.purpleBox;
        totals.redBox += game.earnedItem.redBox;
        totals.total += Object.values(game.earnedItem).reduce((acc, val) => acc + val, 0);
      });

      setTotal([{ ...totals, count: data.length }]);
    } else {
      setTotal([EMPTY_TOTAL]);
    }
  }, [data]);

  const columns = [
    {
      title: '총 게임 수',
      dataIndex: 'count',
      align: 'center'
    },
    {
      title: '등수 평균',
      align: 'center',
      render: (stat) => `${(stat.gameRank / stat.count).toFixed(2)}`
    },
    {
      title: '플레이 시간 평균',
      align: 'center',
      render: (stat) => `${Math.floor((stat.totalTime / stat.count) / 60)}분 ${((stat.totalTime / stat.count) % 60).toFixed(2)}초`
    },
    {
      title: '채집물 평균',
      children: [
        {
          title: '운석',
          align: 'center',
          render: (stat) => `${(stat.meteor / stat.count).toFixed(2)}`
        },
        {
          title: '생명의 나무',
          align: 'center',
          render: (stat) => `${(stat.treeOfLife / stat.count).toFixed(2)}`
        },
        {
          title: '알파 미스릴',
          align: 'center',
          render: (stat) => `${(stat.alpha / stat.count).toFixed(2)}`
        },
        {
          title: '오메가 포스코어',
          align: 'center',
          render: (stat) => `${(stat.omega / stat.count).toFixed(2)}`
        },
        {
          title: '위클라인',
          align: 'center',
          render: (stat) => `${(stat.wickline / stat.count).toFixed(2)}`
        },
        {
          title: '보라박스',
          align: 'center',
          render: (stat) => `${(stat.purpleBox / stat.count).toFixed(2)}`
        },
        {
          title: '빨간 박스',
          align: 'center',
          render: (stat) => `${(stat.redBox / stat.count).toFixed(2)}`
        },
        {
          title: '총합',
          key: 'total',
          align: 'center',
          render: (stat) => (
            <span>
              <div>{(stat.total / stat.count).toFixed(2)}</div>
              <div style={{ fontSize: '0.77em' }}>
                ({((stat.total / stat.count) * 100 / TOTAL_SUPPLY).toFixed(2)}%)
              </div>
            </span>
          )
        }
      ]
    }
  ];

  return (
    <Table
      className='table-wrapper-with-border'
      pagination={false}
      dataSource={total}
      columns={columns}
      loading={loading}
      rowKey="count"
      scroll={{ x: 'max-content' }}
    />
  );
}
